import EditableTextField from '@/components/Lead/EditableTextField';
import PhoneNumberFormat from '@/components/format/PhoneNumberFormat';

const AgentPhone = ({
  agent,
}: {
  agent: any;
  readonly?: boolean;
}) => {
  const phone = agent?.phone;

  return (
    <EditableTextField editable={false} property={'agent.phone'}>
      <PhoneNumberFormat phoneNumber={phone} variant="link" />
    </EditableTextField>
  );
};

export default AgentPhone;
